<script setup lang="ts">
  const emits = defineEmits<{ close: [] }>()
</script>

<template>
  <v-row class="mx-auto" no-gutters>
    <v-spacer />

    <slot />

    <v-col class="d-flex justify-end">
      <v-btn
        color="grey-100"
        rounded="pill"
        size="38"
        slim
        variant="plain"
        @click="emits('close')"
      >
        <v-icon icon="mdi-close" size="24" />
      </v-btn>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">

</style>
